import 'slick-carousel';

(function($, Drupal) {
  Drupal.behaviors.carousels = {
    attach: function(context, settings) {
      if ($('.layout-builder-configure-block').length) {
        return;
      }
      const slickSettings = {
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      };

      const sliderElements = [
        '.slick-wrap .field--name-field-directory-slides',
        '.slick-wrap .field--name-field-images .field__items',
        '.field--name-field-images-with-captions',
        '.view-linkedin-posts .view-content',
        '.slick-wrap .field--name-field-alumni-testimonies'
      ];

      function updateSlideHeight(tallestSlide) {
        const slick_track = document.querySelector('.slick-track');
        const slides = slick_track.querySelectorAll('.linkedin-post');

        // Go through each slide and change the height to the tallest slide, skipping the tallest slide
        slides.forEach(slide => {
          if (slide !== tallestSlide) {
            slide.style.height = tallestSlide.offsetHeight + 'px';
          }
        });
      }

      sliderElements.forEach(sliderElement => {
        $(context).find(sliderElement).once('carousels').each(function(index) {
          let $thisSlider = $(this);

          // If the slider is the view-linkedin-posts slider, chance the slidesToShow to 2 & slidesToScroll to 2
          if (sliderElement === '.view-linkedin-posts .view-content') {
            slickSettings.slidesToShow = 2;
            slickSettings.slidesToScroll = 2;
            slickSettings.adaptiveHeight = false;
            // Add breakpoint of 992px and below to show 1 slide at a time
            slickSettings.responsive = [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ];
          }

          // Alumni testimonies: reset to single-slide defaults before initializing
          if (sliderElement === '.slick-wrap .field--name-field-alumni-testimonies') {
            slickSettings.slidesToShow = 1;
            slickSettings.slidesToScroll = 1;
            slickSettings.dots = false;
            slickSettings.arrows = true;
            delete slickSettings.adaptiveHeight;
            delete slickSettings.responsive;
          }

          $thisSlider.slick(slickSettings);

          if (sliderElement === '.slick-wrap .field--name-field-alumni-testimonies') {
            const totalSlides = $thisSlider.slick('getSlick').slideCount;
            const $sliderPrev = $thisSlider.find('.slick-prev').first();
            const $sliderNext = $thisSlider.find('.slick-next').first();
            const $prev = $('<button class="slick-prev-trigger" aria-label="Previous" type="button">Previous</button>');
            const $next = $('<button class="slick-next-trigger" aria-label="Next" type="button">Next</button>');
            const $counter = $('<span class="slick-counter"><span class="slick-current-slide">1</span> of <span class="slick-total-slides">' + totalSlides + '</span></span>');
            const $wrapper = $('<div class="button-wrapper alumni-counter-wrapper"></div>').append($prev, $counter, $next);
            $thisSlider.prepend($wrapper);

            $prev.on('click', function() { $sliderPrev.trigger('click'); });
            $next.on('click', function() { $sliderNext.trigger('click'); });

            $thisSlider.on('afterChange', function(event, slick, currentSlide) {
              $thisSlider.find('.slick-current-slide').text(currentSlide + 1);
            });
          }

          if (sliderElement === '.view-linkedin-posts .view-content') {
            const slides = document.querySelectorAll('.linkedin-post');
            let tallestSlide = slides[0];

            slides.forEach(slide => {
              if (slide.offsetHeight > tallestSlide.offsetHeight) {
                tallestSlide = slide;
              }

              let slideBody = slide.querySelector('.field--name-body');

              // Use regex to find any anchorless links inside of slideBody and convert the empty link texts into actual links
              if (slideBody) {
                // Find any https:// or http:// links that are not inside of an anchor tag
                const regex = /(?:http|https):\/\/[^\s<]+/g;
                const matches = slideBody.innerHTML.match(regex);
                if (matches) {
                  matches.forEach(match => {
                    slideBody.innerHTML = slideBody.innerHTML.replace(match, '<a href="' + match + '" target="_blank">' + match + '</a>');
                  });
                }
              }
            });

            // Set 20ms timeout
            setTimeout(() => {
              tallestSlide.classList.add('tallest-slide');
              updateSlideHeight(tallestSlide);
            }, 20);

            window.addEventListener('resize', () => {
              updateSlideHeight(tallestSlide);
            });
          }

          if (sliderElement !== '.slick-wrap .field--name-field-alumni-testimonies') {
            $(this).append('<div class="button-wrapper" id="button-wrapper-' + index + '"></div>');
            let $slick_buttons = $(this).find('.slick-dots');
            let $slider_prev_button = $(this).find('.slick-prev').first();
            let $slider_next_button = $(this).find('.slick-next').first();
            let $prev_button = '<button class="slick-prev-trigger" id="slide-prev-trigger-' + index + '" aria-label="Previous" type="button" style="">Previous</button>';
            let $next_button = '<button class="slick-next-trigger" id="slide-next-trigger-' + index + '" aria-label="Next" type="button" style="">Next</button>';

            $('#button-wrapper-' + index).once('append-buttons').append($prev_button, $slick_buttons, $next_button);

            $('#slide-prev-trigger-' + index).on('click', function() {
              $slider_prev_button.trigger('click');
            });

            $('#slide-next-trigger-' + index).on('click', function() {
              $slider_next_button.trigger('click');
            });
          }
        });
      });
    }
  };

})(jQuery, Drupal);
